<template>
  <page>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Credit Card List</div>
        </div>
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-flex>
      </v-card-title>
      <v-flex xs12 class="mt-3">
        <message :messages="messages"></message>
      </v-flex>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="cardListCode" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.cardListCode }}</td>
          <td class="text-xs-left">{{ props.item.cardListDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" query @query="doQuery(props)" review @review="doReview(props)" remove @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-card-text>
        <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
          Add Credit Card List
          <v-icon right>mdi-credit-card-multiple</v-icon>
        </v-btn>
      </v-card-text>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Credit Card List?
        <div class="title">{{deleteCrCdList}}</div>
      </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Card List Code', align: 'left', value: 'cardListCode', sortable: false },
        { text: 'Card List Description', align: 'left', value: 'cardListDesc', sortable: false },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      loading: false,
      items: [],
      promptRemove: false,
      selectedCrCdList: undefined,
      deleteCrCdList: ''
    }
  },
  methods: {
    async doInit() {
      await this.queryCreditCardLists()
    },
    async queryCreditCardLists() {
      const apiURI = this.$store.state.promotionManagement.menu.creditCardLists
      if (apiURI) {
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((creditCardList) => {
                const convertCreditCardList = {
                  cardListCode: creditCardList.cardListCode,
                  cardListDesc: creditCardList.cardListDesc
                }
                this.items.push(convertCreditCardList)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doNew() {
      this.resetMessages()
      this.$router.push({ name: 'creditCardListReview', params: { cardListCode: 'new' } })
    },
    doQuery(data) {
      this.resetMessages()
      if (data && data.item && data.item.cardListCode) {
        this.$router.push({ name: 'creditCardListQuery', params: { cardListCode: data.item.cardListCode } })
      }
    },
    doReview(data) {
      this.resetMessages()
      if (data && data.item && data.item.cardListCode) {
        this.$router.push({ name: 'creditCardListReview', params: { cardListCode: data.item.cardListCode } })
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCrCdList = data
        this.deleteCrCdList = data.cardListCode + ' - ' + data.cardListDesc
      }
    },
    async doRemove() {
      this.resetMessages()
      const apiURI = this.$store.state.promotionManagement.menu.creditCardListDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          cardListCode: this.selectedCrCdList.cardListCode,
          cardListDesc: this.selectedCrCdList.cardListDesc
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryCreditCardLists()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
